<template>
	<section class="padding-60 bg-light testimonial-section">
		<div class="container">
			<div class="title fxt-title">
				<span>What Our Clients Say</span>
				<h2 class="fxt-rev-dev">This is What We Live For</h2>
				<p>
					Our web and mobile app development expertise have helped several organizations
					turn critical challenges into a competitive advantage. But don’t take our word
					for it! Hear straight from our clients what they think and feel about our
					services.
				</p>
			</div>
			<div class="row align-items-center">
				<div class="col-12 col-lg-6">
					<div class="testimonials_left" style="width: unset !important">
						<ul class="testimonials_circle">
							<li>
								<a
									href="javascript:;"
									title="Nick Konechny"
									data-slide="1"
									class="test-img"
								>
									<img
										class="lazy"
										alt="A trainer and student mobile application developed for AK Microblading training of the UK. "
										src="../../assets/images/nick-konechny.jpg"
										style=""
										width="71"
										height="71"
									/> </a
								><i class="fas fa-quote-left"></i>
							</li>
							<li>
								<a
									href="javascript:;"
									title="Zia Mahmood"
									data-slide="2"
									class="test-img"
								>
									<img
										class="lazy"
										alt="A live streaming app development for the UK based startup "
										src="../../assets/images/zia-mahmood.jpg"
										style=""
										width="71"
										height="71"
									/> </a
								><i class="fas fa-quote-left"></i>
							</li>
							<li>
								<a
									href="javascript:;"
									title="Tony Nealon"
									data-slide="3"
									class="test-img"
								>
									<img
										class="lazy"
										alt="Website designing and development for the restaurant business in Timperley"
										src="../../assets/images/3.jpg"
										style=""
										width="71"
										height="71"
									/> </a
								><i class="fas fa-quote-left"></i>
							</li>
							<li>
								<a
									href="javascript:;"
									title="Scott Etherington"
									data-slide="4"
									class="test-img"
								>
									<img
										class="lazy"
										alt="An on-demand food delivery application developed for earning rewards on every order."
										src="https://www.intelivita.co.uk/assets/frameworks/public/images/author/scott-etherington.jpg"
										style=""
										width="71"
										height="71"
									/> </a
								><i class="fas fa-quote-left"></i>
							</li>
							<li>
								<a
									href="javascript:;"
									title="Mukul Verma"
									data-slide="5"
									class="test-img"
								>
									<img
										class="lazy"
										alt="Do you have this in mind- hockey app is offered by which company? yes, MN Webbased developed a hockey mobile game app for a remote mobile game developer."
										src="../../assets/images/mukul-verma.jpg"
										style=""
										width="71"
										height="71"
									/> </a
								><i class="fas fa-quote-left"></i>
							</li>
							<li>
								<a
									href="javascript:;"
									title="Jack Parkin"
									data-slide="6"
									class="test-img"
								>
									<img
										class="lazy"
										alt="Instant messaging chat app development service for a UK based entrepreneur."
										src="../../assets/images/jack-parkin.jpg"
										style=""
										width="71"
										height="71"
									/> </a
								><i class="fas fa-quote-left"></i>
							</li>
							<li>
								<a
									href="javascript:;"
									title="Imogen Venn"
									data-slide="7"
									class="test-img"
								>
									<img
										class="lazy"
										alt="A Virtual Reality application developed for Microsoft art of work with an association of Pebble Studios"
										src="https://www.intelivita.co.uk/assets/frameworks/public/images/author/imogen-venn.jpg"
										style=""
										width="71"
										height="71"
									/> </a
								><i class="fas fa-quote-left"></i>
							</li>
							<li>
								<a
									href="javascript:;"
									title="Tref Griffiths"
									data-slide="8"
									class="test-img active"
								>
									<img
										class="lazy"
										alt="an award-winning crime-solving adventure mobile game app developed and played by over 250,000 budding detectives"
										src="../../assets/images/tref-griffiths.jpg"
										style=""
										width="71"
										height="71"
									/> </a
								><i class="fas fa-quote-left"></i>
							</li>
						</ul>
						<div class="testimonials_privew">
							<div>
								<img
									id="testimonials_privew"
									class="lazy"
									alt="app development companies"
									src="../../assets/images/tref-griffiths.jpg"
									style=""
								/>
							</div>
							<i class="fas fa-quote-left"></i>
						</div>
					</div>
				</div>
				<div class="col-12 col-lg-6 pr-0">
					<div class="testimonials_text">
						<!--          <div
                          class="testimonial-text-section"
                          data-index="8"
                          style="width: 100%; display: inline-block"
                        >
                          <div class="testimonials_text_box">
                            <div class="testimonials-arrow"></div>
                            <i class="fas fa-quote-left"></i>
                            <p>
                              They offer a cost-effective service and I was
                              happy with the experience.” They accurately
                              translated existing app features to iOS and even
                              made slight improvements. Users love the iOS
                              version and post positive reviews of it on the App
                              Store. Offering local management staff and
                              offshore development, MN Webbased provided an
                              excellent service at a great price.
                            </p>
                            <span
                              ><strong>Tref Griffiths</strong>, Owner, CluedUpp
                              Games</span
                            >
                          </div>

                        </div> -->

						<VueSlickCarousel
							class="testimonials_text_slider"
							style="max-width: 350px; margin: auto"
						>
							<div
								class="testimonial-text-section"
								data-index="8"
								style="width: 100%; display: inline-block"
							>
								<div class="testimonials_text_box" style="min-with: 100%">
									<div class="testimonials-arrow"></div>
									<i class="fas fa-quote-left"></i>
									<p>
										They offer a cost-effective service and I was happy with the
										experience.” They accurately translated existing app
										features to iOS and even made slight improvements. Users
										love the iOS version and post positive reviews of it on the
										App Store. Offering local management staff and offshore
										development, MN Webbased provided an excellent service at a
										great price.
									</p>
									<span
										><strong>Tref Griffiths</strong>, Owner, CluedUpp
										Games</span
									>
								</div>
							</div>
							<div
								class="testimonial-text-section"
								data-index="8"
								style="width: 100%; display: inline-block"
							>
								<div
									class="testimonials_text_box"
									style="min-with: 250px; max-width: 280px"
								>
									<div class="testimonials-arrow"></div>
									<i class="fas fa-quote-left"></i>
									<p>
										They offer a cost-effective service and I was happy with the
										experience.” They accurately translated existing app
										features to iOS and even made slight improvements. Users
										love the iOS version and post positive reviews of it on the
										App Store. Offering local management staff and offshore
										development, MN Webbased provided an excellent service at a
										great price.
									</p>
									<span
										><strong>Tref Griffiths</strong>, Owner, CluedUpp
										Games</span
									>
								</div>
							</div>
						</VueSlickCarousel>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';

export default {
	components: {VueSlickCarousel}
};
</script>

<style>
@media (max-width: 576px) {
	.fxt-rev-dev {
		font-size:20px !important;
		font-weight:bold !important;
	}
	.testimonials_left {
		height: 250px !important;
		margin-top:0 !important
	}
	.fxt-title {
		margin-bottom:0px !important
	}
}
</style>
